import ISelectOption from "@/models/generic/iselect-option";
import IInstructor from "@/models/instructors/iinstructor";
import { get } from "./base-service";

const baseUrl = "config"

export async function GetRoomTypes(): Promise<ISelectOption[]> {

    const response = await get(`${baseUrl}/room-types`);

    return response.json();
}

export async function GetBookingOptions(): Promise<ISelectOption[]> {

    const response = await get(`${baseUrl}/booking-options`);

    return response.json();
}

export async function GetInstructors(): Promise<IInstructor[]> {

    const response = await get(`${baseUrl}/instructors`);

    return response.json();
}

export async function GetRetreatStatuses(): Promise<ISelectOption[]> {

    const response = await get(`${baseUrl}/retreat-statuses`);

    return response.json();
}

export async function GetVenues(): Promise<ISelectOption[]> {

    const response = await get(`${baseUrl}/venues`);

    return response.json();
}

export async function GetSeasons(): Promise<ISelectOption[]> {

    const response = await get(`${baseUrl}/seasons`);

    return response.json();
}

export async function GetPaymentMethods(): Promise<ISelectOption[]> {
    const response = await get(`${baseUrl}/payment-methods`);

    return response.json();
}

export async function GetRetreatCostTypes(): Promise<ISelectOption[]> {
    const response = await get(`${baseUrl}/retreat-cost-types`);

    return response.json();
}